<template>
  <div class="service-page">
    
    <div style="width: 1120px;margin: 0 auto;">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>服务机构</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 顶部背景区域 -->
     <div class="header-filter" style="width: 100%;">
        <div class="header-section">
            <div class="title">
                <img src="../../assets/img/serviceOrganization/titleBg.png" alt="">
            </div>
            <div class="search-bar">
                <el-input
                placeholder="服务机构 请输入关键字"
                v-model="searchKeyword"
                class="search-input"
                @keyup.enter.native="filterList"
                >
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
                <el-button type="primary" style="background-color: #0371FF;" class="search-btn" @click="filterList">搜索</el-button>
            </div>

            <!-- 质量领域筛选 -->
            <div class="filter-group">
                <span class="filter-label">质量领域</span>
                <el-radio-group v-model="qualityFieldId" class="radio-group"  @change="filterList">
                    <el-radio-button 
                    :label="item.value" 
                    v-for="item in qualityList" 
                    :key="item.value"
                    >
                    {{ item.text }}
                    </el-radio-button>
                </el-radio-group>
            </div>

            <!-- 产品分类筛选 -->
            <div class="filter-group" v-if="this.qualityFieldId == 'jyjc'">
                <span class="filter-label">产品分类</span>
                <el-radio-group v-model="productCategoryId" class="radio-group" @change="filterList">
                    <el-radio-button 
                    :label="item.value" 
                    v-for="item in productList" 
                    :key="item.value"
                    >
                    {{ item.text }}
                    </el-radio-button>
                </el-radio-group>
            </div>
        </div>
     </div>

    <!-- 机构列表 -->
    <div class="institution-list">
      <div class="institution-card" v-for="(item, index) in filteredList" :key="index" @click="toJump(item.website)">
        <div class="card-title">
          <!-- <i class="el-icon-office-building"></i> -->
           <img src="../../assets/img/serviceOrganization/cardHome.png" style="height: 27px;width: 24px;margin-right: 7px;" alt="">
          <span>{{ item.name }}</span>
        </div>
        <div class="card-info">
          <p>
            <!-- <i class="el-icon-phone"></i>  -->
           <img src="../../assets/img/serviceOrganization/dianhua.png" style="height: 15px;width: 15px;margin-right: 8px;" alt="">
            联系方式:{{ item.phone }}
        </p>
          <p>
            <!-- <i class="el-icon-location"></i>  -->
           <img src="../../assets/img/serviceOrganization/dizhi.png" style="height: 15px;width: 15px;margin-right: 8px;" alt="">
            地址:{{ item.address }}
        </p>
        </div>
      </div>
    </div>
      <!-- <div class="bottom">
         <el-pagination
            @size-change="handleSizeChange"
            @current-change="onCurrentChange"
            :current-page="pageNo"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            @prev-click="prePage"
            @next-click="nextPage"
            :total="total">
          </el-pagination>
      </div> -->
  </div>
</template>

<script>
import { Server, httpurl } from '@/server';
export default {
  name: 'ServiceInstitution',
  data() {
    return {
        searchKeyword: '',
        // 质量领域数组
        qualityList: [
        // { id: 'all', name: '全部' },
        // { id: '1', name: '检验检测' },
        // { id: '2', name: '计量服务' },
        // { id: '3', name: '标准服务' },
        // { id: '4', name: '认证服务' }
        ],
        qualityFieldId: 'all', // 默认选中 检验检测 的 id
        // 产品分类数组
        productList: [
            // { id: 'all', name: '全部' },
            // { id: '1', name: '食品及农产品' },
            // { id: '2', name: '建筑工程' },
            // { id: '3', name: '机械设备' },
            // { id: '4', name: '生活用品' },
            // { id: '5', name: '文教娱乐' },
            // { id: '6', name: '农业相关' },
            // { id: '7', name: '皮革及纺织品' },
            // { id: '8', name: '工业产品' },
            // { id: '9', name: '电子电器' },
            // { id: '10', name: '医药医疗' }
        ],
        productCategoryId: 'all', // 默认选中 建筑工程 的 id
        filteredList: [],
        pageNo:1,
        pageSize:-1,//10
        total:0
    }
  },
  mounted() {
    this.getDictFun()
    this.filterList()
  },
  methods: {
    getDictFun() {
      Server.getDict('cpfl').then(res => {
          console.log(res);
          if(res.success) {
              this.productList = [
                {
                  value:'all',
                  text:'全部'
                },
                ...res.result
              ]
          }
      })
      Server.getDict('zlly').then(res => {
          console.log(res);
          if(res.success) {
              this.qualityList = [
                {
                  value:'all',
                  text:'全部'
                },
                ...res.result
              ]
          }
      })
    },
    // 搜索按钮点击
    handleSearch() {
        console.log("搜索关键词：", this.searchKeyword)
        
        console.log("质量领域ID：", this.qualityFieldId)
        console.log("质量领域名称：", this.qualityList.find(i => i.id === this.qualityFieldId)?.name)
        
        console.log("产品分类ID：", this.productCategoryId)
        console.log("产品分类名称：", this.productList.find(i => i.id === this.productCategoryId)?.name)
    },
    filterList() {
        const keyword = "*" + this.searchKeyword.trim() + "*"
        const qId = this.qualityFieldId=='all'?'':this.qualityFieldId
        let pId = ""
        if (this.qualityFieldId == 'jyjc') {
          pId = this.productCategoryId=='all'?'':this.productCategoryId
        } else {
          this.productCategoryId = 'all'
        }
        console.log(keyword,qId,pId);

        Server.getServerOrganizationList({cpflCx:pId,zllyCx:qId,name:keyword,pageNo:this.pageNo,pageSize:this.pageSize}).then(res => {
            console.log(res);
            if(res.success) {
                this.filteredList = res.result.records
                this.total = res.result.total
            }
        })
    },
    toJump(url) {
      window.open(url,'_blank')
    },
    onCurrentChange(page) {
        this.pageNo = page
        this.filterList()
    },
    prePage() {
        this.pageNo = this.pageNo - 1;
        this.filterList()
    },
    nextPage() {
        this.pageNo = this.pageNo + 1;
        this.filterList()
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val
      this.filterList()
    },
}
}
</script>

<style scoped>
/* 页面整体 */
.service-page {
  width: 100%;
  /* min-height: 100vh; */
  background-color: #f5f7fa;

  /* position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh; */
}

.header-filter {
  width: 100%;
  background: url('../../assets/img/serviceOrganization/filterBg.png') center/cover no-repeat;
  box-sizing: border-box;

  padding-top: 70px;
}


/* 顶部背景区域 */
.header-section {
  width: 1120px;
  margin: 0 auto;
  padding: 10px 10px 40px
}

/* 标题 */
.title {
  font-size: 36px;
  color: #2b7de9;
  text-align: center;
  margin-bottom: 30px;
  font-weight: bold;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* 搜索栏 */
.search-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.search-input {
  /* width: 60%; */
  height: 50px;
  border-radius: 8px 0 0 8px;
}

.search-input >>> .el-input__inner {
  height: 50px;
  line-height: 50px;
  font-size: 16px;

  border-radius: 15px 0 0 15px;
}

.search-btn {
  height: 50px;
  border-radius: 0 8px 8px 0;
  width: 100px;
  font-size: 16px;
}

/* 筛选组 */
.filter-group {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 5px 0;
  padding: 0 10px
}

.filter-label {
  color: #696969;
  margin-right: 15px;
  white-space: nowrap;
  font-size: 13px;
}

.radio-group >>> .el-radio-button__inner {
  background-color: transparent;
  border: none;
  color: #333;
  padding: 8px 15px;
  font-size: 13px;
}

.radio-group >>> .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background-color: #0371FF;
  color: #fff;
  border-radius: 15px;
}

/* 关掉 el-radio-button 所有过渡动画 */
::v-deep .el-radio-button__inner {
  transition: none !important;
}
::v-deep .el-radio-button__inner::after {
  transition: none !important;
}

/* 机构列表 */
.institution-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  /* background-color: #eee; */
  /* margin-bottom: 20px; */
  padding: 10px;

  width: 1120px;
  margin: 20px auto;
  /* margin: 0 20px; */
}

.institution-card {
  background-color: #fff;
  padding: 20px;
}

.card-title {
  display: flex;
  align-items: end;
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-bottom: 15px;
}

.card-title i {
  font-size: 24px;
  color: #2b7de9;
  margin-right: 7px;
}
.card-info {
    padding: 0 25px;
    margin-top: 20px;
}

.card-info p {
  display: flex;
  align-items: center;
  font-size: 13px;
  color: #666;
  margin: 8px 0;
}

.card-info p i {
  color: #2b7de9;
  margin-right: 8px;
}

 .bottom {
            display: flex;
            justify-content: flex-end;
            padding: 10px;
            width: 1120px;
            margin: 20px auto;
        }
</style>